import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import amTranslation from './locales/am/translation.json';
import omTranslation from './locales/om/translation.json';

// Get persisted language from localStorage if available
const getPersistedLanguage = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState) {
      const state = JSON.parse(serializedState);
      return state.language.selectedLanguage;
    }
  } catch (e) {
    console.warn('Could not get persisted language', e);
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    am: { translation: amTranslation },
    om: { translation: omTranslation },
  },
  lng: getPersistedLanguage(), // Use persisted language from Redux store
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
